import { AppBar, Box, IconButton, Link, Paper, Toolbar } from '@mui/material';
import { styled } from '@mui/system';

export const DetailLink = styled(Link)(() => ({
  display: 'inline-block',
  mt: 2,
  mb: 2,
  typography: 'h6',
  color: 'primary',
  '&:hover': {
    textDecoration: 'none',
  },
  '& .MuiLink-root': {
    cursor: 'pointer',
  },
}));

export const HeaderButtons = styled(IconButton)(({ theme }) => ({
  color: `${theme.palette.primary.main}`,
}));

export const HeaderToolbar = styled(Toolbar)(() => ({
  paddingBottom: '0.2rem',
  paddingLeft: '4rem !important',
  paddingRight: '4rem !important',
  paddingTop: '0.2rem',
}));

export const LoginPaper = styled(Paper)(({ theme }) => ({
  padding: '2em',
  display: 'flex',
  flexDirection: 'column',
  gap: 1 * 8,
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '30%',
    minWidth: '500px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const ModalBox = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: 10,
  boxShadow: 24,
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: '75vw',
}));

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  position: 'fixed',
  zIndex: 100,
}));
